import { OrganizerType } from "../../../../../shared/types/OrganizerTypes"
import { UserType } from "../../../../login/loginTypes"

export type MeetingOrderDetails = Readonly<{
    meetingName: string
    location: string
    meetingTimeAsText: string
    startDateTime: string
    endDateTime: string
    meetingDuration: number
    isExternal: boolean
}>

export type MeetingOrderOrganizer = Readonly<{
    organizerType: OrganizerType
    type: OrganizerType
    id: number
    uid: string
    name: string
    email: string
    businessPhone: string
    mobilePhone: string
    company: {
        id: number
        name: string
    }
}>

export type MeetingDetailsOrder = Readonly<{
    id: number
    uid: string
    messages: Array<{
        id: number
        body: string
        publishDate: string
        sender: {
            type: UserType
            serviceCenterId: number
            userId: number
        }
    }>
    attendees: Array<MeetingAttendee>
    meetingDetails: MeetingOrderDetails
    organizers: Array<MeetingOrderOrganizer>
    accountingCustomerParty?: { name: string }
}>

export enum AttendeeState {
    CHECKED_IN = "CHECKED_IN",
    EXPECTED = "EXPECTED",
}

export type MeetingAttendee = Readonly<{
    id: number
    name: string
    companyName: string
    isExternal: boolean
    state: AttendeeState
}>

